var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5998 8.05591V6.86131C3.5998 3.83586 6.00838 1.3999 8.99981 1.3999C11.9912 1.3999 14.3998 3.83586 14.3998 6.86131V8.65325M8.99981 14.6854V12.2854M16.1998 13.432C16.1998 17.3908 12.9763 20.6001 8.99981 20.6001C5.02335 20.6001 1.7998 17.3908 1.7998 13.432C1.7998 9.47315 5.02335 6.26388 8.99981 6.26388C12.9763 6.26388 16.1998 9.47315 16.1998 13.432Z",
    stroke: "#2D3036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9f910c11afafe55dc3b1892b847310ef.svg";
export { ForwardRef as ReactComponent };